var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-list"},_vm._l((_vm.answers),function(answer,index){return _c('AnswerItem',{key:index,attrs:{"name":answer.name || '',"answer":answer,"isActive":answer.is_check},on:{"onAnswerClick":_vm.onAnswerClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }